import { cva, type VariantProps } from 'class-variance-authority';
import { uiMarker, uiMarkerLayout } from './shared';

/**
 * BREAKDOWN LIST
 *
 * A ranked list where every row carries its own bar, drawn behind the text at
 * that row's share of the biggest one. The shape of the list is readable
 * before any of it is read — which page, which city, which referrer is the
 * one that matters. The analytics page drew this as a ul with an absolutely
 * positioned span in every li.
 *
 * The bar is a static width, not an animation: it is a measurement, not an
 * event.
 */
export const breakdownListRecipe = cva([
  uiMarker,
  uiMarkerLayout,
  'm-0 flex list-none flex-col gap-1 p-0',
]);

export const breakdownItemRecipe = cva([
  uiMarker,
  'relative overflow-hidden rounded-md',
]);

/** The bar behind the row. Sized inline, since the width is data. */
export const breakdownBarRecipe = cva(
  [uiMarker, 'absolute inset-y-0 left-0 rounded-md'],
  {
    variants: {
      tone: {
        primary: 'bg-primary/10',
        muted: 'bg-muted',
      },
    },
    defaultVariants: { tone: 'primary' },
  }
);

/** The text, laid over the bar. */
export const breakdownRowRecipe = cva([
  uiMarker,
  uiMarkerLayout,
  'relative flex flex-row items-center justify-between gap-3 px-2 py-1.5',
]);

export type BreakdownBarRecipeProps = VariantProps<typeof breakdownBarRecipe>;
